import toast from 'react-hot-toast';

/**
 * Report the Google Calendar outcome of saving an open home / inspection.
 *
 * Every inspection write is now mirrored to the hosting agents' own Google
 * Calendars automatically (Monday 12757422009 - "when an agent puts an
 * inspection time through CRM please update there google calendar with time &
 * date"). The backend returns a `calendar_sync` block on the response:
 *
 *   { synced: [], not_connected: [], failed: [], removed: [], message: '' }
 *
 * Showing it matters because the two failure cases - the agent has never
 * connected a calendar, or their Google token has expired - are otherwise
 * completely silent, and look identical to the sync being broken.
 */
export function reportCalendarSync(data) {
  const sync = data?.calendar_sync;
  if (!sync?.message) return;

  const needsAttention = (sync.not_connected?.length || 0) > 0 || (sync.failed?.length || 0) > 0;
  if (needsAttention) {
    toast(sync.message, { icon: '📅', duration: 6000 });
  } else {
    toast.success(sync.message);
  }
}

export default reportCalendarSync;
